"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var each_1 = require("./each");
var is_array_like_1 = require("./is-array-like");
var map = function (arr, func) {
    if (!is_array_like_1.default(arr)) {
        // @ts-ignore
        return arr;
    }
    var result = [];
    each_1.default(arr, function (value, index) {
        result.push(func(value, index));
    });
    return result;
};
exports.default = map;
//# sourceMappingURL=map.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/map.js
// module id = 1132
// module chunks = 37